import React, { FC, useMemo } from 'react'

import { TextLinkProps } from '../A'

import * as SC from './styled'

export type BreadcrumbProps = {
  hoverColor?: string
  className?: string
  links: TextLinkProps[]
  truncate?: number
  parent?: any
  bgColor?: string
}

const Breadcrumb: FC<BreadcrumbProps> = (props) => {
  const { hoverColor, className, links, truncate = -1, bgColor } = props

  const renderLinks = useMemo(() => {
    return links.map((link, index) => (
      <SC.BreadcrumbListItem
        key={`breadcrumb__item--${index}`}
        bgColor={bgColor}
      >
        <SC.BreadcrumbLink
          bgColor={bgColor}
          hoverColor={hoverColor}
          href={link?.href}
          dangerousInsert
        >
          {index === links.length - 1 &&
          link &&
          truncate > 0 &&
          link.text.length > truncate
            ? `${link?.text.substring(0, truncate)} [...]`
            : link?.text}
        </SC.BreadcrumbLink>
      </SC.BreadcrumbListItem>
    ))
  }, [links, bgColor, hoverColor, truncate])

  return (
    <SC.Container bgColor={bgColor} className={className}>
      {renderLinks}
    </SC.Container>
  )
}

export default Breadcrumb
